import React from "react";
import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import SEO from "../../hooks/SEO";
import PageBanner from "../../components/PageBanner";
import ContactForm from "../../components/Contact/Contact";
import ContactInfoCard from "../../components/ContactInfoCard";
import SectionHeader from "../../components/SectionHeader";
import { contactDetails, seoContent, siteMeta } from "../../data/mockData";

const Contact = () => (
  <>
    <SEO
      title={seoContent.contact.title}
      description={seoContent.contact.description}
      name={siteMeta.name}
      type="website"
    />
    <PageBanner
      title="Contact Refwa"
      description="For formal inquiries, please use the contact details shown below."
      image={siteMeta.bannerImage}
      breadcrumbs={[{ label: "Contact" }]}
    />

    <Box className="site-section">
      <Container>
        <Paper
          sx={{
            p: { xs: 3, md: 3.8 },
            mb: { xs: 4.5, md: 5.5 },
            border: "1px solid var(--color-border)",
            boxShadow: "var(--shadow-card)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="start" sx={{ width: "100%", m: 0 }}>
            <Grid item xs={12} lg={7}>
              <SectionHeader
                eyebrow="Direct Contact"
                title="Formal Inquiries"
                description="Inquiries may be directed through the official contact details shown on this page. The form may be used to prepare inquiry details before formal submission."
              />
            </Grid>
            <Grid item xs={12} lg={5}>
              <Stack spacing={1.3} sx={{ pt: { lg: 4.5 } }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Inquiries can cover mining support, petroleum services, international trade, construction and industrial works, environmental response, facility support, and broader portfolio capability discussions.
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Please use the listed contact details for direct correspondence with Refwa.
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={3} sx={{ width: "100%", m: 0 }}>
          {contactDetails.map((detail) => (
            <Grid item xs={12} md={6} lg={4} key={detail.title}>
              <ContactInfoCard {...detail} />
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={{ xs: 3, md: 4 }} sx={{ mt: { xs: 4, md: 5 }, width: "100%", m: 0 }}>
          <Grid item xs={12} lg={7}>
            <ContactForm />
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box
              sx={{
                p: { xs: 3, md: 3.5 },
                borderRadius: "var(--radius-panel)",
                background:
                  "linear-gradient(180deg, rgba(15,27,45,0.98), rgba(23,39,60,0.96))",
                color: "#fff",
                height: "100%",
                border: "1px solid rgba(255,255,255,0.1)",
                boxShadow: "var(--shadow-strong)",
              }}
            >
              <Typography variant="h4">Correspondence</Typography>
              <Typography
                variant="body1"
                sx={{ mt: 2.25, color: "rgba(255,255,255,0.78)", lineHeight: 1.85 }}
              >
                The form may be used to organize inquiry details before formal submission through the listed email address or other official contact channels.
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 2.25, color: "rgba(255,255,255,0.78)", lineHeight: 1.85 }}
              >
                Suitable inquiry topics include mining support, petroleum services, international trade, construction and industrial works, environmental services, facility support, and broader portfolio capability discussions.
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 2.4, color: "primary.light", fontWeight: 700 }}
              >
                Direct contact email: {siteMeta.email}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);

export default Contact;
